import React, { memo, useCallback } from 'react';
import { Select } from 'antd';
import { indexes } from './config';
import { useKeepExistingIds } from './hooks/useKeepExistingIds';
import BaseSelect from './BaseSelect';
import OptGroupLabel from './OptGroupLabel';
import styles from './index.module.scss';

const SelectHouses = ({
  options,
  ids,
  value,
  propsRef,
  loading,
  notFoundContent,
  map,
}) => {
  const onChange = useCallback(
    (ids) => {
      const { value, onChange: changeHandler } = propsRef.current;
      const nextVal = ids?.length
        ? [value[indexes.street], ids, value[indexes.room]]
        : [value[indexes.street], [], []];
      changeHandler(nextVal);
    },
    [propsRef]
  );

  useKeepExistingIds({
    propsRef,
    index: indexes.house,
    loading,
    ids,
    onChange,
  });

  return (
    <BaseSelect
      loading={loading}
      placeholder="Дома"
      value={value}
      onChange={onChange}
      notFoundContent={notFoundContent}
      optionLabelProp="label"
    >
      {Object.entries(options || {}).map(({ 0: entityId, 1: items }) => {
        const entityName = map?.get(entityId) || '';

        return (
          <Select.OptGroup
            key={entityId}
            label={<OptGroupLabel>{entityName}</OptGroupLabel>}
          >
            {items.map((item) => {
              const content = `${item.name} (${item.houseTypeName})`;

              return (
                <Select.Option
                  key={item.id}
                  searchtext={`${entityName}${item.houseTypeName}${item.name}`}
                  value={item.id}
                  label={
                    <OptionLabel
                      entityName={entityName}
                      content={content}
                    />
                  }
                >
                  {content}
                </Select.Option>
              );
            })}
          </Select.OptGroup>
        );
      })}
    </BaseSelect>
  );
};

export default memo(SelectHouses);

function OptionLabel({ entityName, content }) {
  return (
    <>
      <div className={styles.accent}>{entityName}</div>
      {content}
    </>
  );
}
